export default __webpack_public_path__ + "static/media/montenegro.8fc36ac6.svg";